import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from 'react-bootstrap'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../../context/SocketContext'
import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas'
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'

import { SelectElement } from '../../components/selectElement2'
import LoadingOverlay from '../../components/LoadingOverlay'
import { NoAcceso } from '../../components/NoAcceso'
import { serverApi } from '../../api'
import { CrearModuloModal } from './components/CrearModuloModal'
import { GestionarModuloClasesModal } from './components/GestionarModuloClasesModal'



const pasarMayusculas = (ev) => {
    ev.target.value = ev.target.value.toUpperCase();
}


const MySwal = withReactContent(Swal);
const sweet = (title, html, icon) => { MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000 }) }
const sweetConfirm = (title, html, icon) => {
    return MySwal.fire({

        title,
        html,
        icon,
        confirmButtonText: 'Ok',
        confirmButtonColor: 'LightSeaGreen',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
    })
}


export const ModulosCreacion = () => {

    let [usuario] = useState(getUsuarioStorage());
    const pantallas = useGetPantallas();
    const navigate = useNavigate();
    const { socket } = useContext(SocketContext);

    useHideMenu(false);

    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showClasesModal, setShowClasesModal] = useState(false);

    const [ubicaciones, setUbicaciones] = useState([]);


    const [searchInput, setSearchInput] = useState('');

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'modulo',
        sortDir: 'asc',
        ideUbicacion: '',
        codigoUbicacion: '',
    });
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const totalPages = Math.max(1, Math.ceil(total / query.limit));


    useEffect(() => {
        if (!usuario?.uidUsuario) navigate('/Ingreso');
    }, [usuario, navigate]);

    //Select-ubicaciones
    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");

        if (!codigoEntidad) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/ubicaciones/select-ubicaciones`, { codigoEntidad });

                const opciones = resp.data.data.map((item) => ({ value: item.ideUbicacion, label: item.nombreUbicacion.toUpperCase(), data: item.codigoUbicacion }))
                setUbicaciones(opciones);

                const ubicacionUsuario = opciones.find(
                    u => u.data === usuario.codigoUbicacion
                );

                if (ubicacionUsuario) {
                    setQuery(prev => ({
                        ...prev,
                        ideUbicacion: ubicacionUsuario.value,
                        codigoUbicacion: ubicacionUsuario.data
                    }));
                }

            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            } finally {

            }
        };

        fetch();

    }, [usuario])

    const handleSelectUbicacion = (selected) => {

        setQuery(prev => ({
            ...prev,
            page: 1,
            ideUbicacion: selected.value,
            nombreUbicacion: selected.label,
            codigoUbicacion: selected.data
        }));
    };


    //Carga inicial de los Modulos
    useEffect(() => {
        const load = async () => {

            const codigoEntidad = usuario.codigoEntidad;
            const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
            if (!codigoEntidad || !codigoUbicacion) return;

            try {
                setIsLoading(true);

                const resp = await serverApi.post('/modulos/lista-modulos', {
                    ...query,
                    codigoEntidad,
                });

                console.log(resp.data);

                setData(resp.data.listaModulos || []);
                setTotal(resp.data.total || 0);

            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };

        load();
    }, [query, usuario]);

    useEffect(() => {

        if (!socket) return;


        const handler = (lista) => {
            console.log(lista);
            setData(lista.listaModulos);
            setTotal(lista.total || 0);
        };

        socket.on('lista-modulos', handler);

        return () => socket.off('lista-modulos', handler);

    }, [socket])

    // const handleSearch = (ev) => {
    //     setQuery(prev => ({
    //         ...prev,
    //         search: ev.target.value,
    //         page: 1
    //     }));
    // };

    useEffect(() => {
        const timeout = setTimeout(() => {

            if (searchInput.trim().length > 0 && searchInput.trim().length < 2) return;

            setQuery(prev => {
                if (prev.search === searchInput) return prev; // 🔥 evita re-render

                return {
                    ...prev,
                    search: searchInput,
                    page: 1
                };
            });

        }, 1000);

        return () => clearTimeout(timeout);

    }, [searchInput]);

    const paginate = (page) => {
        if (page < 1 || page > totalPages) return;

        setQuery(prev => ({
            ...prev,
            page
        }));
    };

    const handleSort = (field) => {
        setQuery(prev => ({
            ...prev,
            sortBy: field,
            sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc'
        }));
    };



    const inactivaModulo = async (uidModulo, accion) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null || !codigoUbicacion || codigoUbicacion === null) return sweet('Atención!', 'Revise la infromación', 'error');

        const act = accion === 1 ? "Activar" : "Inactivar";

        const confirmacion = await sweetConfirm("Atención", `Esta seguro de ${act} el registro?`, "warning").then((result) => {
            return (result);
        })

        if (!confirmacion.value) return false;

        // uidModulo= uidModulo;
        // datos.accion= accion;

        try {

            await serverApi.post(
                `/modulos/inactiva-modulo`,
                {
                    ...query,
                    uidModulo,
                    accion,
                    codigoEntidad,
                    codigoUbicacion,
                }
            );

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }


    const registraModulo = async (datos) => {

        console.log(datos);


        const codigoEntidad = localStorage.getItem("codigoEntidad");
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

        try {

            setIsLoading(true);
            const res = await serverApi.post(
                `/modulos/registra-modulo`,
                {
                    ...query,
                    ...datos,
                    codigoEntidad,

                }
            );

            if (res.data.ok === false) {
                sweet('', res.data.resp, 'error');
            } else {
                sweet('', res.data.resp, 'success');
                setShowModal(false)
            }


        } catch (error) {
            // sweet('Atención!', res[1], 'error');
            console.error(error);
        } finally {
            setIsLoading(false);

        }


    }

    const editaModulo = async (ev, uidModulo) => {

        const campo = ev.target.id.split("_")[0];
        const valor = (ev.target.type === 'checkbox') ? ev.target.checked : ev.target.value;
        const valorAnterior = (ev.target.type === 'checkbox') ? ev.target.checked : ev.target.defaultValue;


        if (valor !== valorAnterior || ev.target.type === 'checkbox') {

            const confirmacion = await sweetConfirm("Atención", "Esta seguro de Modificar el registro?", "warning");
            if (!confirmacion.value) {

                // restaurar visualmente checkbox
                if (ev.target.type === 'checkbox') {
                    ev.target.checked = valorAnterior;
                } else {
                    ev.target.value = valorAnterior;
                }

                return;
            }

            // Actualización optimista del estado local
            if (campo === 'recibeTraslados') {
                setData(prev =>
                    prev.map(item =>
                        item.uidModulo === uidModulo
                            ? {
                                ...item,
                                recibeTraslados: valor
                            }
                            : item
                    )
                );
            }


            try {
                const codigoEntidad = usuario.codigoEntidad;
                const codigoUbicacion = usuario.codigoUbicacion;
                const codigoUbicacionEditar = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;


                if (!codigoEntidad || codigoEntidad === null || !codigoUbicacion || codigoUbicacion === null) return sweet('Atención!', 'Revise la infromación', 'error');

                await serverApi.post(
                    `/modulos/edita-modulo`,
                    {
                        ...query,
                        campo,
                        valor,
                        uidModulo,
                        codigoEntidad,
                        codigoUbicacion,
                        codigoUbicacionEditar
                    }
                );



            } catch (error) {
                console.error(error);

                if (campo === 'recibeTraslados') {
                    setData(prev =>
                        prev.map(item =>
                            item.uidModulo === uidModulo
                                ? {
                                    ...item,
                                    recibeTraslados: valorAnterior
                                }
                                : item
                        )
                    );
                }

            } finally {
                setIsLoading(false);

            }



        }


    }



    if (usuario.uidUsuario === null) {
        return (
            <>
            </>
        )
    }
    else if (!pantallas.includes("creacionescritorios")) {
        return (<NoAcceso />)
    }
    else {

        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{ minHeight: '100vh' }}>

                    <div>

                        <div className='col-lg-12 col-12 mb-3 d-flex gap-2 flex-wrap'>

                            <button
                                className="btn btn-success"
                                onClick={() => setShowModal(true)}
                            >
                                <i className="fa-solid fa-plus me-1"></i> Crear módulo
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={() => setShowClasesModal(true)}
                                style={{ background: '#0d7367', borderColor: '#0d7367' }}
                            >
                                <i className="fa-solid fa-tags me-1"></i> Crear clase de módulo
                            </button>

                            <CrearModuloModal
                                show={showModal}
                                onClose={() => setShowModal(false)}
                                ubicaciones={ubicaciones}
                                onSave={(data) => {
                                    registraModulo(data)

                                }}
                            />

                            <GestionarModuloClasesModal
                                show={showClasesModal}
                                onClose={() => setShowClasesModal(false)}
                            />

                        </div>




                        <div className='row rounded shadow p-3'>

                            <div className='col-12 col-md-4'>

                                <div className='p-3'>
                                    <label>Sede/ubicación</label>
                                    <SelectElement
                                        options={ubicaciones}
                                        name={`idUbicacion`}
                                        isMulti={false}
                                        closeOnMenuSelect={true}
                                        value={ubicaciones.find(u => u.value === query.ideUbicacion)}
                                        onChange={(selected) => handleSelectUbicacion(selected)}
                                        classname="form-control form-control-lg"
                                        isClearable={false}
                                    />

                                </div>
                            </div>

                            <div className='col-12'>
                                <div className='float-start col-lg-4 col-12 pagination'>

                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(query.page - 1)}
                                        disabled={query.page === 1}
                                    >
                                        {'<'}
                                    </button>

                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(query.page + 1)}
                                        disabled={query.page >= totalPages}

                                    >
                                        {'>'}
                                    </button>

                                </div>

                                <div className=' float-end col-lg-4 col-12'>

                                    <input
                                        type='text'
                                        placeholder='Buscar...'
                                        className='form-control'
                                        maxLength={20}
                                        // defaultValue={query.search}
                                        // onChange={ (ev) => handleSearch(ev)}
                                        value={searchInput}
                                        onChange={(ev) => setSearchInput(ev.target.value)}
                                    />

                                </div>

                            </div>

                            <div className='col-12'>
                                <Table responsive="md" striped hover style={{ minWidth: 600 }} className='max400'>
                                    <thead>
                                        <tr>
                                            <th width={'5%'}></th>
                                            <th width={'20%'} onClick={() => handleSort('nombreUbicacion')} >
                                                Ubicación
                                                {query.sortBy === 'nombreUbicacion' && query.sortDir === 'asc' && '▲'}
                                                {query.sortBy === 'nombreUbicacion' && query.sortDir === 'desc' && '▼'}
                                            </th>
                                            <th width={'20%'} onClick={() => handleSort('moduloClase')} >
                                                Clase
                                                {query.sortBy === 'moduloClase' && query.sortDir === 'asc' && '▲'}
                                                {query.sortBy === 'moduloClase' && query.sortDir === 'desc' && '▼'}
                                            </th>
                                            <th width={'40%'} onClick={() => handleSort('modulo')} >
                                                Módulo
                                                {query.sortBy === 'modulo' && query.sortDir === 'asc' && '▲'}
                                                {query.sortBy === 'modulo' && query.sortDir === 'desc' && '▼'}
                                            </th>

                                            <th width={'15%'}  >
                                                Recibe Traslado
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody width={'100%'}  >

                                        {

                                            data.length === 0
                                                ? (<tr>
                                                    <td width={'100%'} style={{ textAlign: 'center' }}> No Hay Registros </td>
                                                </tr>
                                                )
                                                :
                                                data.map((item) => (

                                                    <tr key={item.uidModulo}>
                                                        <td width={'5%'}>

                                                            {(item.indActivo === 1)
                                                                ? (
                                                                    <button
                                                                        className='btn btn-sm btn-danger'
                                                                        onClick={() => inactivaModulo(item.uidModulo, 0)}
                                                                    >
                                                                        <i className='fa-solid fa-minus'></i>
                                                                    </button>
                                                                )
                                                                : (
                                                                    <button
                                                                        className='btn btn-sm btn-success'
                                                                        onClick={() => inactivaModulo(item.uidModulo, 1)}
                                                                    >
                                                                        <i className='fa-solid fa-plus'></i>
                                                                    </button>
                                                                )

                                                            }



                                                        </td>

                                                        <td width={'20%'}>
                                                            {item.nombreUbicacion.toUpperCase()}

                                                        </td><td width={'20%'}>
                                                            {item.moduloClase.toUpperCase()}

                                                        </td>
                                                        <td width={'45%'}>
                                                            {(item.indActivo === 1)
                                                                ? (
                                                                    <input
                                                                        type='text'
                                                                        className='form-control'
                                                                        id={`modulo_${item.uidModulo}`}
                                                                        defaultValue={item.modulo.toUpperCase()}
                                                                        maxLength={20}
                                                                        onBlur={(ev) => editaModulo(ev, item.uidModulo)}
                                                                        onChange={(ev) => pasarMayusculas(ev)}
                                                                    />
                                                                )
                                                                : (
                                                                    item.modulo.toUpperCase()

                                                                )

                                                            }
                                                        </td>
                                                        <td width={'15%'}>

                                                            <div className="form-check form-switch">
                                                                {/* { console.log(typeof(item.uidModulo), typeof(moduloSeleccionado) ) } */}
                                                                <input
                                                                    className="form-check-input"
                                                                    checked={item.recibeTraslados}
                                                                    type="checkbox"
                                                                    id={`recibeTraslados_${item.uidModulo}`}
                                                                    onChange={(ev) => editaModulo(ev, item.uidModulo)}

                                                                />

                                                                <label className="form-check-label" htmlFor="chkAsignado_"></label>
                                                            </div>


                                                        </td>

                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </Table>
                            </div>

                            <div className='pagination'>
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(query.page - 1)}
                                    disabled={query.page === 1}
                                >
                                    {'<'}
                                </button>
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(query.page + 1)}
                                    disabled={query.page >= totalPages}
                                >
                                    {'>'}
                                </button>
                                <span className='m-2'>
                                    {query.page} / {totalPages}
                                </span>
                            </div>

                        </div>


                    </div>



                </div>
            </>
        )
    }
}
